/* eslint-disable  */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
/* eslint-disable  */
// @ts-nocheck
import * as React from 'react';
import { DataRouteMatch, matchRoutes, Params, RouteObject, useLocation } from 'react-router-dom';
import AppRoute, { MainRoutes } from '../routes/App.route';
import { Box } from '@mui/material';
import './Header.styles.css';
import AdditionalResources from '../components/AdditionalResources/AdditionalResources.components';
import VisitOurWebsite from '../components/VisitOurWebsite/VisitOurWebsite.components';
import Header from './Header';
import SigninModal from './SigninModal';
import SignupModal from './SignupModal';
import { useAppSelector, useInitStore } from '../store/hooks';
import Loader from '../components/Loader/Loader.component';

const Layout = () => {
  const location = useLocation();
  const [{ route }] = matchRoutes(MainRoutes, location) || [{}];

  const { populateDataFromCache } = useInitStore();
  const { loader, userData } = useAppSelector((state) => state.user);

  React.useLayoutEffect(() => {
    populateDataFromCache();
  }, [populateDataFromCache]);

  // Start Dialog Modal Code
  // const [openSignin, setOpenSignin] = React.useState(false);
  // const [openSignup, setOpenSignup] = React.useState(false);
  // const [openDeleteaccount, setOpenDeleteaccount] = React.useState(false);
  // End Dialog Modal Code

  const initiated = React.useRef(true);

  const sendRegisteredUserDL = () => {
    const { dataLayer } = window;
    dataLayer.push({
      event: 'registeredUser',
      email: userData?.user?.email,
    });
  };

  React.useEffect(() => {
    if (initiated.current && userData?.token) {
      initiated.current = false;
      sendRegisteredUserDL();
    }
  }, [sendRegisteredUserDL]);

  return (
    <Box>
      {loader && <Loader />}
      {!route?.withoutHeader && (
        <>
          <Header
          // onClickSignin={() => setOpenSignin(true)}
          // onClickSignup={() => setOpenSignup(true)}
          // onClickDeleteaccount={() => setOpenDeleteaccount(true)}
          />
          <SigninModal
          // open={openSignin} handleClose={() => setOpenSignin(false)}
          />
          <SignupModal
          // open={openSignup} handleClose={() => setOpenSignup(false)}
          />
        </>
      )}
      <AppRoute />
      {!route?.withoutFooter && (
        <Box className="FooterWrapper">
          <AdditionalResources />
          <VisitOurWebsite />
        </Box>
      )}
    </Box>
  );
};

export default Layout;
